import { createAsyncThunk } from '@reduxjs/toolkit';
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

export const getBabyNames = createAsyncThunk(
  'babyNames/babyNames',
  async (params = {}, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.BABY_NAMES.GET_BABY_NAMES, {
        params,
      });

      if (response.data?.success) {
        return response.data?.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch baby names'
        );
      }
    } catch (error) {
      console.error('baby names API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching baby names'
      );
    }
  }
);

export const toggleNameSave = createAsyncThunk(
  'babyNames/toggleNameSave',
  async (name_id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.BABY_NAMES.TOGGLE_NAME_SAVE}/${name_id}`
      );
      if (response.data?.success) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch baby names'
        );
      }
    } catch (error) {
      console.error('baby names API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching baby names'
      );
    }
  }
);

export const getMySavedNames = createAsyncThunk(
  'babyNames/getMySavedNames',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        URLS.BABY_NAMES.GET_MY_SAVED_NAMES
      );
      if (response.data?.success) {
        return response.data?.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch baby names'
        );
      }
    } catch (error) {
      console.error('baby names API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching baby names'
      );
    }
  }
);
